// extracted by mini-css-extract-plugin
module.exports = {"fullContainer":"_17ahdHe9ceyWDe059L4Prd","titleContainer":"_3JXkCC7DFAGvHk6N6CpmFo","contentContainer":"_2ak66vwldc9JdeEsqMjeWa"};